import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';

export const ErrorCallout = ({ children }) => {
    return (
        <div
            className={cn(
                'tw-flex tw-items-start tw-gap-[12px] tw-p-[16px] tw-font-[500] tw-rounded-[8px]',
                'tw-text-black tw-bg-[#FCE2DA] tw-border tw-border-[#F4511E]'
            )}
        >
            <img src='/assets/images/x-octagon.svg' title='criminal record checked' alt='check-circle' />
            <span>{children}</span>
        </div>
    );
};

ErrorCallout.propTypes = {
    children: PropTypes.node.isRequired
};
